// extracted by mini-css-extract-plugin
export var content = "_qq-1";
export var noScroll = "_qq-3";
export var paper = "_qq-0";
export var scrollable = "_qq-2";